import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    ResponsiveContainer,
    CartesianGrid,
    Tooltip,
    LabelList,
    Cell,
} from 'recharts';
import { roundHalfUpInteger } from '../../pages/selfcare/selfcareReportLogic';

const renderValueLabel = (props) => {
    const { x, y, width, height, value } = props;
    const v = Number(value);

    const cx = (x || 0) + (width || 0);
    const cy = (y || 0) + (height || 0) / 2;

    return (
        <text
            x={cx + 8}
            y={cy}
            fill="#334155"
            fontSize={10}
            fontWeight={800}
            dominantBaseline="middle"
            textAnchor="start"
        >
            {`${Number.isFinite(v) ? roundHalfUpInteger(v) : 0}`}
        </text>
    );
};

const RiskProfilesBarChartSelfcare = ({ profiles }) => {
    if (!profiles || profiles.length === 0) return null;

    const data = profiles.map((p) => {
        const value = Number.isFinite(Number(p.level)) ? Number(p.level) : 0;
        return {
            name: p.shortTitle || p.title,
            value,
            color: p.color,
        };
    });

    const height = Math.max(190, data.length * 22 + 40);

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const value = payload[0].value;
            return (
                <div style={{ backgroundColor: 'white', padding: 10, border: '1px solid #ccc' }}>
                    <div style={{ fontWeight: 700 }}>{label}</div>
                    <div style={{ fontWeight: 600, color: '#3E246B' }}>{roundHalfUpInteger(value)}%</div>
                </div>
            );
        }
        return null;
    };

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={data} layout="vertical" margin={{ top: 22, right: 36, bottom: 0, left: 10 }}>
                <CartesianGrid stroke="#e8e8e8" vertical horizontal={false} />
                <XAxis
                    type="number"
                    domain={[0, 100]}
                    ticks={[0, 25, 50, 75, 100]}
                    tick={{ fontSize: 10, fill: '#8c8c8c' }}
                    tickFormatter={(v) => `${v}%`}
                    axisLine={false}
                    tickLine={false}
                    orientation="top"
                />
                <YAxis
                    type="category"
                    dataKey="name"
                    width={180}
                    interval={0}
                    tick={{ fontSize: 10, fill: '#5b5b5b' }}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip content={<CustomTooltip />} wrapperStyle={{ zIndex: 1000 }} />
                <Bar dataKey="value" barSize={12} radius={[0, 8, 8, 0]}>
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                    <LabelList
                        dataKey="value"
                        content={renderValueLabel}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default RiskProfilesBarChartSelfcare;
